import { Component, inject } from '@angular/core';
import { GlobalButtonComponent } from '../../../shared/components/global-button/global-button.component';
import { PictureComponent } from '../../../shared/components/picture/picture.component';
import { JumpToComponent } from '../../../shared/components/jump-to/jump-to.component';
import { GlobalModalService } from '../../../shared/services/global-modal.service';

@Component({
  selector: '[callouts]',
  imports: [GlobalButtonComponent, PictureComponent],
  templateUrl: './callouts.component.html',
  styleUrl: './callouts.component.scss',
})
export class CalloutsComponent {
  cardButton = {
    buttonLabel: 'Download',
    buttonUrl: 'assets/pdf/type-1-diabetes-c-peptide-guide.pdf',
    openInNewTab: true,
    buttonIcon: 'download-icon',
  };

  private modalService = inject(GlobalModalService);

  navigateTo(url: string, e: Event) {
    e.preventDefault();
    this.modalService.openModal('interstitial', url);
  }
}
